<template>
  <v-flex xs12 md6>
    <v-card class="adder-card hp-adder">
      <v-checkbox :label="component.title" v-model="chosen" @change="toggleComponent"></v-checkbox>
      <v-img width="100%" :src="imagePreview(component)"></v-img>
      <v-layout row align-end>
        <v-flex shrink v-if="component.previews || component.preview">
          <v-btn class="modal-btn" @click.stop="dialog = true">View</v-btn>
          <v-dialog v-model="dialog" lazy max-width="1170px">
            <component-modal :component="component" :chosen="chosen" v-on:closing="dialog = false" v-on:choosed="chosen = true"></component-modal>
          </v-dialog>
        </v-flex>
        <v-flex class="package-note d-flex align-center justify-end" v-if="component.packages.length > 0">
          <span><span class="material-icons">verified</span>&nbsp;Included in the Sokal {{ component.packages[0] }} website package</span>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import ComponentModal from './ComponentModal'
import { mapGetters } from 'vuex'

export default {
props: ['component'],
data() {
    return {
      dialog: false,
      chosen: false
  }
},
mounted() {
  this.setChosen();
},
computed: {
  ...mapGetters(
      ['imagePreview', 'chosenArray']
  ),
},
methods: {
  setChosen() {
    if (this.containsObject(this.component, this.chosenArray)) {
      this.chosen = true;
    } else {
      this.chosen = false;
    }
  },
  toggleComponent() {
    if (this.containsObject(this.component, this.chosenArray)) {
      for (var i = 0; i < this.$store.state.chosenComponents.length; i++) {
        if (this.$store.state.chosenComponents[i] === this.component) {
          this.$store.state.chosenComponents.splice(i,1);
        }
      }
    }
    else {
      this.$store.state.chosenComponents.push(this.component);
    }
  },
  containsObject(obj, list) {
    var i;
    for (i = 0; i < list.length; i++) {
        if (list[i] === obj) {
            return true;
        }
    }
    return false;
  }
},
watch: {
  chosenArray: function() {
    this.setChosen();
  }
},
components: {
    componentModal: ComponentModal
  }
}
</script>

<style scoped>
.modal-btn {
  margin: 12px 0px 0px;
  font-weight: 500;
  min-width: unset;
  background-color: #006aff !important;
  color: #fff;
  height: unset;
  padding: 8px 16px;
  font-size: 12px;
  letter-spacing: .5px;
}
.adder-card {
  padding: 24px;
  border-radius: 9px;
  box-shadow: 0px 3px 10px 4px rgb(0 106 255 / 8%), 0px 2px 2px 0px rgb(0 83 199 / 9%), 0px 1px 5px 0px rgb(0 83 199 / 9%);
}
.package-note {
  text-align: right;
}
.package-note .material-icons {
  color: #006aff;
  font-size: 20px;
  position: relative;
  top: 4px;
}
</style>

<style>
.adder-card .v-input--selection-controls .v-input__control, .adder-card .v-input--selection-controls .v-icon, .adder-card {
  color: #006aff;
}
.adder-card .v-input--selection-controls.v-input .v-label {
  color: #000;
}
.adder-card .v-input--selection-controls {
  margin-top: 0px;
}
.adder-card .card-title .v-input__slot {
  margin-bottom: 0;
}
.adder-card.hp-adder .v-image {
  border-radius: 0px !important;
}
</style>